import { motion } from "framer-motion";
import { Image } from "lucide-react";
import PageBanner from "@/components/PageBanner";
import OptimizedImage from "@/components/OptimizedImage";

const galleryImages = [
  {
    src: "/5O5A0010w.webp",
    alt: "Lion",
    span: "md:col-span-2 md:row-span-2"
  },
  {
    src: "/gorillatrekking.png",
    alt: "Mountain Gorilla",
    span: "md:col-span-1"
  },
  {
    src: "/giraffesunset.jpg",
    alt: "Giraffe in the Savannah",
    span: "md:col-span-1"
  },
  {
    src: "/buffalo.png",
    alt: "Buffalo",
    span: "md:col-span-1"
  },
  {
    src: "/chimpazee.png",
    alt: "Chimpanzee",
    span: "md:col-span-1"
  },
  {
    src: "/5O5A9186.JPG",
    alt: "Scenic Landscape",
    span: "md:col-span-2"
  },
  {
    src: "/giraffe.webp",
    alt: "Giraffe",
    span: "md:col-span-1 md:row-span-2"
  },
  {
    src: "/crested-crane.jpg",
    alt: "Crested Crane",
    span: "md:col-span-1"
  },
  {
    src: "/zebraserengeti.webp",
    alt: "Zebras in Serengeti",
    span: "md:col-span-2"
  },
  {
    src: "/5O5A9051.png",
    alt: "Hippopotamus",
    span: "md:col-span-1"
  }
];

export default function Gallery() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageBanner
        title="Photo Gallery"
        description="Explore the breathtaking beauty of East Africa through our lens"
        backgroundImage="/lens.png"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 auto-rows-[200px] md:auto-rows-[250px] lg:auto-rows-[300px]">
          {galleryImages.map((image, index) => (
            <motion.div
              key={image.src}
              className={`relative overflow-hidden rounded-2xl group ${image.span}`}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <OptimizedImage
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
                priority={index < 4} // Prioritize loading first 4 images
                size={image.span.includes("col-span-2") ? "large" : "medium"}
                blurDataURL={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 5'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='1'/%3E%3C/filter%3E%3Crect preserveAspectRatio='none' filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' fill='%23${Math.floor(Math.random() * 16777215).toString(16)}'/%3E%3C/svg%3E`}
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white text-center px-4 text-lg font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  {image.alt}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}